export default "__VITE_ASSET__DsmUaTzR__"